import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { cycleTimeReportEntrypoint } from '@atlassian/jira-spa-apps-software-reports-cycle-time-report/entrypoint.tsx';

export const cycleTimeReportClassicPageEntrypoint = createPageEntryPoint({
	main: cycleTimeReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
